import { jsx } from 'panel';
import { ContextPanelEl } from 'common/widgets/context-panel';
import { SectionEl, SectionRowEl } from './section'; // eslint-disable-next-line import/no-cycle

import { SectionItemEl, SectionItemSubMenuEl } from './section/item';

const EmptySearchResult = _ref => {
  let {
    message
  } = _ref;
  return jsx("ul", {
    sel: '.screen-options-list'
  }, jsx("li", {
    sel: '.list-option.list-empty'
  }, jsx("div", {
    sel: '.option-label'
  }, message)));
};

const SectionList = _ref2 => {
  let {
    comp
  } = _ref2;
  const sections = comp.helpers.getDisplaySections();
  const sectionsHint = comp.attr("sections-hint");
  const searchFilter = comp.attr("search-filter");
  const isMultiple = comp.attr("multiple");
  const alignAllText = comp.attr("align-all-text");
  const {
    contextPanelTransform,
    focusedItemIndex,
    isPillFocused,
    isSubItemsOpen,
    fullyShownSections
  } = comp.state;

  if (sections.length) {
    return jsx(null, null, sectionsHint && jsx("div", {
      sel: '.sections-hint'
    }, sectionsHint), sections.map((section, idx) => jsx(null, null, idx > 0 && !section.hideTopDivider && jsx("div", {
      sel: '.section-divider'
    }), jsx(SectionEl, {
      section: section,
      hideSectionTitle: section.isHidden && !fullyShownSections[section.wrappedSectionIndex]
    }, section.items.map(item => {
      var _a, _b;

      const hasSubSections = item.subSections && item.subSections.length;
      const isFocused = focusedItemIndex === item.index;
      const shouldDisplaySubSections = hasSubSections && isFocused && !item.isDisabled && isSubItemsOpen;
      return jsx(SectionRowEl, {
        item: item,
        isFocused: isFocused,
        isMultiple: isMultiple,
        contextPanelTransform: contextPanelTransform,
        onClick: comp.helpers.handleClickItem,
        onMouseEnter: comp.helpers.handleMouseenterItem,
        onMouseLeave: comp.helpers.handleMouseleaveItem
      }, jsx(SectionItemEl, {
        item: item,
        isPillFocused: isPillFocused,
        isMultiple: isMultiple,
        isFocused: isFocused,
        alignAllText: alignAllText,
        displayAllSelectOne: section.displayAllSelectOne,
        actionsRenderer: (_a = item.actionsRenderer) !== null && _a !== void 0 ? _a : section.actionsRenderer,
        iconRenderer: (_b = item.iconRenderer) !== null && _b !== void 0 ? _b : section.iconRenderer,
        onActionClick: comp.helpers.handleClickPill,
        onActionMouseEnter: comp.helpers.handleMouseenterPill,
        onActionMouseLeave: comp.helpers.handleMouseleavePill
      }), shouldDisplaySubSections && jsx(SectionItemSubMenuEl, {
        sections: item.subSections,
        allignAllText: comp.attr("align-all-text"),
        dropdownPositioning: comp.helpers.getDropdownPositioning("subItemsEl"),
        isMultiple: isMultiple,
        contextPanelTransform: contextPanelTransform,
        keydownProxyEl: comp.keydownProxyEl || comp,
        onNavigateBack: comp.helpers.handleSubItemsNavigateBack,
        onClickItem: comp.helpers.handleSubItemsClickItem,
        onFocusItem: comp.helpers.propagateEvent,
        onInsert: elm => comp.helpers.setElRef("subItemsEl", elm),
        onDestroy: () => comp.helpers.setElRef("subItemsEl", null)
      }));
    })))));
  }

  if (searchFilter) {
    return jsx(EmptySearchResult, {
      message: comp.attr("empty-search-results-message")
    });
  }

  return jsx(EmptySearchResult, {
    message: comp.attr("empty-message")
  });
};

export function template() {
  const {
    tooltipData
  } = this.state;
  const positioning = this.helpers.getDropdownPositioning("contextPanel", {
    addVerticalOffset: false
  });
  return jsx("div", {
    sel: '.items-menu',
    hook: {
      postpatch: this.helpers.handlePostPatch
    }
  }, tooltipData && jsx(ContextPanelEl, {
    attrs: {
      elref: "contextPanel",
      'tooltip-data': this.state.tooltipData,
      'relative-parent-positioning': true
    },
    style: positioning.styles,
    class: {
      ["is-".concat(positioning.horizontal, "-aligned")]: true,
      ["is-".concat(positioning.vertical, "-aligned")]: true
    },
    hook: {
      insert: _ref3 => {
        let {
          elm
        } = _ref3;
        return this.helpers.setElRef("contextPanel", elm);
      },
      destroy: () => this.helpers.setElRef("contextPanel", null)
    }
  }), jsx("div", {
    sel: '.screen-list-container',
    on: {
      scroll: this.helpers.handleScroll
    },
    hook: {
      insert: _ref4 => {
        let {
          elm
        } = _ref4;
        return this.handleInsertScreenListContainer(elm);
      }
    }
  }, jsx(SectionList, {
    comp: this
  })));
}